/* eslint-disable react-hooks/exhaustive-deps */
import {
	Box,
	Text,
	HStack,
	VStack,
	Flex,
	Grid,
	GridItem,
	Skeleton,
	Button,
	Heading,
	useDisclosure,
} from '@chakra-ui/react'
import { BsImageAlt } from 'react-icons/bs'
import React, { useState } from 'react'
import CardDetails from './card-details'
import { loadImageBlob } from '../../utils/aws.util'

const encode = data => {
	let str = data.reduce(function (a, b) {
		return a + String.fromCharCode(b)
	}, '')
	return btoa(str).replace(/.{76}(?=.)/g, '$&\n')
}

const ActivityImage = ({ url }) => {
	const [imgData, setImgData] = useState(null)
	const [imgType, setImgType] = useState(null)
	loadImageBlob(url, (data, type) => {
		setImgData(data)
		setImgType(type)
	})
	return (
		<img
			src={
				imgData !== null ? 'data:' + imgType + ';base64,' + encode(imgData) : ''
			}
			alt={'Dashboard'}
			width={300}
			height={300}
		/>
	)
}

const DrillDownCard = ({ theadings, tdata, isLoading }) => {
	const { isOpen, onClose, onOpen } = useDisclosure()
	const [cardData, setCardData] = useState({})
	const handleCardData = data => {
		setCardData(data)
		onOpen()
	}
	return (
		<>
			<div className='drilldownCard'>
				{tdata.map((grid, i) => {
					return !Array.isArray(grid) ? (
						<GridItem key={i} colSpan={3}>
							<Skeleton key={i} minH='200px' />
						</GridItem>
					) : (
						<Grid
							key={i}
							h='100%'
							w='100%'
							templateColumns='repeat(12, 1fr)'
							gap={3}
						>
							{grid?.map((item, j) => {
								let title = item
									.filter(f => f.db_field_name === 'activity_title')
									.reduce((a, s) => s.value, '')
								let a_image = item?.[0]?.['activity_image_path']
								let a_color = item?.[0]?.['color']
								return (
									<GridItem
										key={`item${j}`}
										colSpan={3}
										cursor={'pointer'}
										onClick={() => handleCardData(item)}
									>
										<Box
											p={5}
											shadow='md'
											borderWidth='1px'
											key={i}
											minH='250px'
											bg={'white'}
										>
											<VStack w={'full'} justifyContent={'center'}>
												<HStack p={5} w={'full'} justifyContent={'center'}>
													{a_image === '' ? (
														<BsImageAlt size={100} color={'gray'} />
													) : (
														<ActivityImage url={a_image} />
													)}
												</HStack>
												<Heading color={a_color} size='sm'>
													{title}
												</Heading>
											</VStack>
										</Box>
									</GridItem>
								)
							})}
						</Grid>
					)
				})}
			</div>
			{isOpen ? (
				<CardDetails card_data={cardData} isOpen={isOpen} onClose={onClose} />
			) : null}
		</>
	)
}

export default DrillDownCard

DrillDownCard.defaultProps = {
	theadings: [],
	tdata: [],
	thLength: 9,
}
